import { cn } from '@/lib/cn'

// Skeleton — gray placeholder block with Tailwind's `animate-pulse`. Used
// for loading states across the operations and admin pages so they don't
// flash a bare "A carregar…" message.
//
// Default sizing is none — callers control width/height via className. The
// primitive ships a sensible default for height (h-4) so a bare
// `<Skeleton className="w-24" />` renders as a one-line bar.

export type SkeletonProps = {
  className?: string
  'aria-label'?: string
}

export function Skeleton({ className, 'aria-label': ariaLabel = 'A carregar…' }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label={ariaLabel}
      aria-busy="true"
      className={cn('h-4 animate-pulse rounded bg-gray-100', className)}
    />
  )
}

// Row of N skeleton cells matched to a table layout. `colSpan` widths are
// passed in via the `widths` array so the placeholders roughly mirror the
// real column proportions and the table doesn't jump on load.
export function SkeletonTableRow({
  widths,
  className,
}: {
  widths: string[]
  className?: string
}) {
  return (
    <tr className={cn('border-b border-DEFAULT last:border-0', className)}>
      {widths.map((w, i) => (
        <td key={i} className="px-4 py-3">
          <Skeleton className={cn('h-3.5', w)} />
        </td>
      ))}
    </tr>
  )
}
